import moment from "moment"
import { Link } from "gatsby"
import { ContentBlocks } from "../../blocks"
import { FooterCTA } from "../../footerCTA"
import { Img } from "../../../layout/Img"

export const ResourceDetail = ({ entry }) => {
  return (
    <>
      <div className="container w-full px-4 pt-10 mx-auto sm:px-10 md:pt-24 lg:w-9/12 ">
        <div className="flex flex-col">
          <div className="flex flex-col">
            <div className="flex">
              {entry.resourceCategory.map((cat, index) => (
                <div
                  key={index}
                  className="px-2 py-1 text-xs uppercase border-2 rounded-full 2xl:text-sm text-secondary border-highlightColor"
                >
                  {cat.title}
                </div>
              ))}
            </div>

            <h1 className="mt-3 mb-4 text-4xl font-semibold leading-none lg:text-5xl xl:text-6xl text-secondary">
              {entry.title}
            </h1>

            <p className="flex py-3 ml-0 text-secondary">
              {moment(entry.postDate).format("DD MMMM Y")}
            </p>

            {entry.authorProfile.map((item) => (
              <div className="flex py-3" key={item.uid}>
                <Link to={`/${item.uri}`}>
                  <p className="mr-3 text-lg text-gray-600">
                    <Img
                      className="w-10 -mt-2 rounded-full"
                      image={item?.profilePicture[0]}
                      imgStyle={{ borderRadius: "100%" }}
                    />
                    <span className="ml-2 text-base text-primary">
                      {item.title}
                    </span>
                  </p>
                </Link>

                {/* <div className="hidden mt-1 xl:block">{" - "}</div> */}


              </div>
            ))}
          </div>
        </div>
      </div>
      {entry?.contentBlocks?.length > 0 && (
        <ContentBlocks blocks={entry.contentBlocks} />
      )}
      {entry?.footerCTA?.length > 0 && (
        <FooterCTA
          ctaHeading={entry.footerCTA[0].ctaHeading}
          ctaLink={entry.footerCTA[0].ctaLink}
        />
      )}
    </>
  )
}
